import PropTypes from "prop-types";
import { useState } from "react";
import { useSnackbar } from "notistack";
import {
  Typography,
  Box,
  Dialog,
  IconButton,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useAuth from "../../../hooks/useAuth";
import { LoadingButton } from "@mui/lab";

SwitchTravelling.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};
export function SwitchTravelling({ open, handleClose }) {
  const { enqueueSnackbar } = useSnackbar();
  const { switchToTravelling } = useAuth();
  const [loading, setLoading] = useState(false);
  const handleSwitch = async () => {
    try {
      setLoading(true);
      await switchToTravelling();
      window.location.href = "https://app.useafritas.com";
      handleClose();
    } catch (error) {
      enqueueSnackbar(
        "An error has occurred while trying to switch! Please try again later.",
        { variant: "error" },
      );
    }
    setLoading(false);
  };
  return (
    <Dialog
      sx={{ textAlign: "left" }}
      maxWidth="xs"
      fullWidth
      open={open}
      onClose={handleClose}
    >
      <Box sx={{ position: "relative" }}>
        <DialogTitle sx={{ fontWeight: 500, fontSize: "1.5rem" }}>
          Confirm you want to switch to customer account?
        </DialogTitle>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
          }}
        >
          <CloseIcon sx={{ color: "rgba(64, 60, 60, 1)" }} />
        </IconButton>
      </Box>
      <DialogContent
        sx={{
          pt: 4,
          textAlign: "start",
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontSize: 13, fontWeight: 400, color: "rgba(64, 60, 60, 1)" }}
        >
          Please note that switching your account to customer will allow you
          book hotels, short-lets, buy tickets for events and attractions, rent
          a boat or automobile.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "start",
          flexDirection: "column",
          borderTop: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <LoadingButton
          onClick={handleSwitch}
          color="primary"
          fullWidth
          sx={{
            px: 4,
            py: 1.2,
            boxShadow: "none",
            fontSize: 13,
            fontWeight: 500,
            color: "rgba(255, 255, 255, 1)",
            mb: 1,
          }}
          variant="contained"
          loading={loading}
        >
          Proceed
        </LoadingButton>
        <Button
          onClick={handleClose}
          color="primary"
          variant="text"
          sx={{
            px: 4,
            py: 1.2,
            boxShadow: "none",
            fontSize: 13,
            fontWeight: 500,
            color: "rgba(64, 60, 60, 1)",
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
